import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-product-modal" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    key: _ctx.$route.fullPath,
    width: $options.modalWidth,
    "is-visible": _ctx.isVisible,
    "has-backdrop": "",
    "show-action-close": "",
    "show-action-back": $options.showActionBack(),
    "is-processing": false,
    variant: $options.getModalVariant(),
    onActionBack: $options.onActionBack,
    onActionClose: $options.onActionClose,
    "data-qa": $options.qaModalName
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view, {
          name: "projectContextModal",
          "data-qa": $options.qa
        }, null, 8 /* PROPS */, ["data-qa"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["width", "is-visible", "show-action-back", "variant", "onActionBack", "onActionClose", "data-qa"]))
}